import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=6ca53286&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"
import style0 from "./CreatePassword.vue?vue&type=style&index=0&id=6ca53286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca53286",
  null
  
)

export default component.exports